(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[710],{

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 80489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations",
      function () {
        return __webpack_require__(62037);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Button_loading = function(param) {
    var text_color = param.text_color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 ".concat(text_color),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button_loading);


/***/ }),

/***/ 33615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_Transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1193);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73935);






function Sidepan(param) {
    var children = param.children, id = param.id, sidepanOpen = param.sidepanOpen, setSidepanOpen = param.setSidepanOpen, justify_align = param.justify_align, closeByOutsideClick = param.closeByOutsideClick, closeByEscClick = param.closeByEscClick, sidepan_component_styles = param.sidepan_component_styles, custom_content_box_styles = param.custom_content_box_styles, hide_back_shadow = param.hide_back_shadow, fixed_main_width = param.fixed_main_width;
    var modalContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setMounted(true);
    }, []);
    // close on click outside
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick) {
            var clickHandler = function(param) {
                var target = param.target;
                var ref;
                if (!sidepanOpen || modalContent.current.contains(target) || (target === null || target === void 0 ? void 0 : (ref = target.id) === null || ref === void 0 ? void 0 : ref.includes("react-select"))) return;
                setSidepanOpen(false);
            };
            document.addEventListener("click", clickHandler);
            return function() {
                return document.removeEventListener("click", clickHandler);
            };
        }
    });
    // close if the esc key is pressed
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick || closeByEscClick) {
            var keyHandler = function(param) {
                var keyCode = param.keyCode;
                if (!sidepanOpen || keyCode !== 27) return;
                setSidepanOpen(false);
            };
            document.addEventListener("keydown", keyHandler);
            return function() {
                return document.removeEventListener("keydown", keyHandler);
            };
        }
    });
    // Return null during SSR
    if (!mounted) return null;
    // Only create portal on client-side
    var portalElement =  true ? document.body : 0;
    if (!portalElement) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_5__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            hide_back_shadow !== true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "fixed inset-0 bg-gray-900 bg-opacity-30 z-100 transition-opacity",
                show: sidepanOpen,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0",
                enterEnd: "opacity-100",
                leave: "transition ease-out duration-100",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: id,
                className: [
                    "fixed inset-0 z-100  overflow-hidden flex items-center    transform ",
                    justify_align ? "justify-".concat(justify_align) : "justify-end",
                    fixed_main_width ? fixed_main_width : "w-auto", 
                ].join(" "),
                role: "dialog",
                "aria-modal": "true",
                show: sidepanOpen,
                enter: "transition ease-in-out duration-200",
                enterStart: "opacity-0 translate-y-4",
                enterEnd: "opacity-100 translate-y-0",
                leave: "transition ease-in-out duration-200",
                leaveStart: "opacity-100 translate-y-0",
                leaveEnd: "opacity-0 translate-y-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: modalContent,
                    className: [
                        "bg-white   shadow-lg overflow-auto  rounded-md  max-h-full  ",
                        sidepan_component_styles !== null && sidepan_component_styles !== void 0 ? sidepan_component_styles : "",
                        custom_content_box_styles, 
                    ].join(" "),
                    children: children
                })
            })
        ]
    }), portalElement);
}
/* harmony default export */ __webpack_exports__["Z"] = (Sidepan);


/***/ }),

/***/ 62037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48777);
/* harmony import */ var _components_Integration_Index_Integrations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50931);
/* harmony import */ var _components_Integration_Index_IntegrationsNewletter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62767);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);







var Index = function(param) {
    var categories = param.categories, integrations = param.integrations;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE. "
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly – Integrations"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " min-h-[60%] max-w-6xl mx-auto pt-12 mb-20 space-y-20 overflow-hidden sm:mb-32 sm:space-y-32 md:mb-40 md:space-y-40 sm:px-4 md:px-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Integration_Index_Integrations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        categories: categories === null || categories === void 0 ? void 0 : categories.categories,
                        integrations: integrations
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Integration_Index_IntegrationsNewletter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ }),

/***/ 59155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _asyncToGenerator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var getUserDetails = (__webpack_require__(10107)/* .getUserDetails */ .M_);
var ref = __webpack_require__(9669), axios = ref.default;
var ref1 = __webpack_require__(60538), getAuthKey = ref1.getAuthKey, getSelectedTenantDetails = ref1.getSelectedTenantDetails;
module.exports = {
    user_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserDetails(getAuthKey()).then(function(res) {
                                return onSuccess(res === null || res === void 0 ? void 0 : res.user);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }(),
    tenant_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                axios.get("/api/user_tenants_details", {
                    params: {
                        auth_key: getAuthKey()
                    }
                }).then(function(res) {
                    onSuccess(getSelectedTenantDetails(res.data.data.tenants));
                });
                return [
                    2
                ];
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 86854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || _nonIterableRest();
}


/***/ }),

/***/ 41451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [46911,61509,9979,3726,17624,13037,87536,19702,63344,81735,91397,4380,48777,74818,56065,49774,92888,40179], function() { return __webpack_exec__(80489); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);